import { Person } from './person';

/**
 * Classe que representa um Veterinário no sistema.
 * @extends Person
 */
export class Vet extends Person {

    /**
     * Instanciar um novo Veterinário
     * @param init - JSON que represente parcialmente as propriedades da classe
     */
    public constructor(init?: Partial<Vet>) {
        super(init);
        Object.assign(this, init);
    }

    /**
     *
     */
    toFirebase(): object {
        return {
            name: this.name,
            document: this.document,
            birthday: this.birthday,
            phone: this.phone,
            user: this.user ? this.user.toFirebase() : null
        };
    }
}
